"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highlight = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function highlight(text, keyword) {
    if (keyword === void 0) { keyword = ""; }
    // eslint-disable-next-line no-param-reassign
    keyword = (keyword || "").trim();
    if ((typeof text !== "string" && typeof text !== "number") || !keyword) {
        return text;
    }
    return String(text)
        .split(keyword)
        .map(function (text, index) {
        var key = text + "-" + index;
        if (index >= 1) {
            return (react_1.default.createElement("span", { key: key },
                react_1.default.createElement("strong", null, keyword),
                text));
        }
        return react_1.default.createElement("span", { key: key }, text);
    });
}
exports.highlight = highlight;
//# sourceMappingURL=text-highlight.js.map